import React, { useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ModalHeader, ModalBody, Typography, Button, LoadingButton, ModalFooter, Link, } from '@one-thd/sui-atomic-components';
import { setOverlayEvent } from '../../../utils/analytics';
export var MultiDeleteUserModal = function (_a) {
    var selectedUsers = _a.selectedUsers, isLoading = _a.isLoading, onConfirmMultiDelete = _a.onConfirmMultiDelete, hideModal = _a.hideModal, handleClose = _a.handleClose, _b = _a.allUsersSelected, allUsersSelected = _b === void 0 ? false : _b;
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    var length = selectedUsers.length;
    var isMultiple = length > 1;
    var userText = isMultiple ? 'users' : 'this user';
    var eachUserText = isMultiple ? 'each user' : 'this user';
    var modalContent = {
        CONFIRMATION: "Are you sure you want to remove ".concat(userText, " from your account?"),
        MESSAGE: "You'll still be able to review previous purchases made by ".concat(eachUserText, "."),
        BUTTON_TEXT: isMultiple
            ? "Yes, Remove ".concat(length, " Users")
            : 'Yes, Remove User',
    };
    var handleCancel = function () {
        hideModal();
        handleClose();
    };
    var height = '';
    if (isMobile && length > 4) {
        height = 'sui-h-[195px]';
    }
    else if (!isMobile && length > 9) {
        height = 'sui-h-[400px]';
    }
    useEffect(function () {
        setOverlayEvent('user management bulk remove user');
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: handleCancel }, "Remove User"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, modalContent.CONFIRMATION),
            allUsersSelected && (React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, { variant: "body-base" },
                    "Note: The account owner can't be removed. Update the account owner details on the\u00A0",
                    React.createElement(Link, { href: "/myaccount/profile" }, "Profile page"),
                    "."))),
            length > 1 && (React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, { variant: "body-base" }, modalContent.MESSAGE))),
            React.createElement("div", { className: "sui-overflow-y-scroll ".concat(height) },
                React.createElement("ul", { className: "sui-list-disc sui-mt-4 sui-ml-6" }, selectedUsers.map(function (user) { return (React.createElement("li", { key: user.userId, className: "sui-mb-4" },
                    React.createElement("div", { className: "sui-flex" },
                        React.createElement(Typography, { variant: "body-base", weight: "bold", "data-qm-mask": "" },
                            user.firstName,
                            " ",
                            user.lastName),
                        "\u00A0",
                        React.createElement(Typography, { variant: "body-base", color: "subtle", weight: "bold" }, "(".concat(user.role, ")"))))); }))),
            length === 1 && (React.createElement(Typography, { variant: "body-base" }, modalContent.MESSAGE))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: handleCancel }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmMultiDelete }, modalContent.BUTTON_TEXT)))));
};
MultiDeleteUserModal.displayText = 'MultiDeleteUserModal';
